import React from 'react'
import { Button } from 'antd'
import Screen from '../../Components/Screen'
import { store } from 'Evolve/store'

import Breadcrumbs from './Components/Breadcrumbs'
import Header from './Components/Header'
import Filters from './Components/Filters'
import Table from './Components/Table'

import Timesheet from '../../Modals/Timesheet'
import TimesheetAdjustment from '../../Modals/TimesheetAdjustment'

type Props = {
  subcontractors: [],
  projects: [],
  timesheets: [],
  componentView: boolean,
  additionalFilter: {},
  fetching: boolean,
  searchTerm: string,
  filters: {},
  pagination: {},
  timesheetModal: boolean,
  timesheetAdjustmentModal: boolean,
  componentDidMount: () => void,
  componentDidUpdate: () => void,
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
  onChangeFilter: () => void,
  onChangeTable: () => void,
  onClickRow: () => void,
  onClickExport: () => void,
  onClickNewTimesheet: () => void,
  onCloseTimesheetModal: () => void,
  didCreateTimesheet: () => void,
  didUpdateTimesheet: () => void,
  didDeleteTimesheet: () => void,
  onClickStartDateTime: () => void,
  onClickEndDateTime: () => void,
  onClickCreateTimesheetAdjustment: () => void,
  onClickTimesheetAmendment: () => void,
  onCloseTimesheetAdjustmentModal: () => void,
}

export default class extends React.PureComponent<Props> {

  componentDidMount = () => this.props.componentDidMount()

  componentDidUpdate = () => {
    if (this.props.componentDidUpdate) {
      this.props.componentDidUpdate(this.props)
    }
  }

  render() {
    
    const {
      componentView,
      additionalFilter,
      subcontractors,
      projects,
      timesheets,
      fetching,
      searchTerm,
      filters,
      pagination,
      timesheetModal,
      timesheetAdjustmentModal,
      onChangeSearch,
      onSubmitSearch,
      onChangeFilter,
      onChangeTable,
      onClickRow,
      onClickExport,
      onClickNewTimesheet,
      onCloseTimesheetModal,
      didCreateTimesheet,
      didUpdateTimesheet,
      didDeleteTimesheet,
      onClickStartDateTime,
      onClickEndDateTime,
      onClickCreateTimesheetAdjustment,
      onClickTimesheetAmendment,
      onCloseTimesheetAdjustmentModal,
    } = this.props

    // Set additionalFilter in store for component view mode
    store.getState().screens.Timesheets.additionalFilter = {}
    if (componentView) {
      store.getState().screens.Timesheets.additionalFilter = additionalFilter || {}
      var projectId = additionalFilter && additionalFilter.project_id

      return (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
            <Filters
              subcontractors={subcontractors}
              projects={projects}
              filters={filters}
              onChangeFilter={onChangeFilter}
              hideProjectFilter={true}
            />
            <Button type="primary" onClick={function() { onClickNewTimesheet(projectId) }}>
              New Timesheet
            </Button>
          </div>

          <Table
            timesheets={timesheets}
            fetching={fetching}
            pagination={pagination}
            projectId={projectId}
            onChangeTable={onChangeTable}
            onClickRow={onClickRow}
            onClickStartDateTime={onClickStartDateTime}
            onClickEndDateTime={onClickEndDateTime}
            onClickCreateTimesheetAdjustment={onClickCreateTimesheetAdjustment}
            onClickTimesheetAmendment={onClickTimesheetAmendment}
          />

          {timesheetModal.show && (
            <Timesheet
              id={timesheetModal.id}
              projectId={timesheetModal.projectId || projectId}
              onClose={onCloseTimesheetModal}
              didCreate={didCreateTimesheet}
              didUpdate={didUpdateTimesheet}
              didDelete={didDeleteTimesheet}
            />
          )}

          {timesheetAdjustmentModal.show && (
            <TimesheetAdjustment
              {...timesheetAdjustmentModal}
              onClose={onCloseTimesheetAdjustmentModal}
            />
          )}
        </div>
      )
    }
    
    return (

      <Screen>

        <Breadcrumbs />

        <Header
          searchTerm={searchTerm}
          onChangeSearch={onChangeSearch}
          onSubmitSearch={onSubmitSearch}
          onClickExport={onClickExport}
          onClickNewTimesheet={onClickNewTimesheet}
        />

        <Filters
          subcontractors={subcontractors}
          projects={projects}
          filters={filters}
          onChangeFilter={onChangeFilter}
        />

        <Table
          timesheets={timesheets}
          fetching={fetching}
          pagination={pagination}
          onChangeTable={onChangeTable}
          onClickRow={onClickRow}
          onClickStartDateTime={onClickStartDateTime}
          onClickEndDateTime={onClickEndDateTime}
          onClickCreateTimesheetAdjustment={onClickCreateTimesheetAdjustment}
          onClickTimesheetAmendment={onClickTimesheetAmendment}
        />

        {timesheetModal.show && (
          <Timesheet
            id={timesheetModal.id}
            onClose={onCloseTimesheetModal}
            didCreate={didCreateTimesheet}
            didUpdate={didUpdateTimesheet}
            didDelete={didDeleteTimesheet}
          />
        )}

        {timesheetAdjustmentModal.show && (
          <TimesheetAdjustment
            {...timesheetAdjustmentModal}
            onClose={onCloseTimesheetAdjustmentModal}
          />
        )}

      </Screen>

    )

  }

}
